<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE GRUPO DE EMPRESAS" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" titleReport="Relátorio de Grupo de Empresas">
                <md-button v-if="permissoes.grupo_empresasCreate" class="md-button md-success md-just-icon md-round" :to="{ name: 'grupo_empresasCreate' }">
                    <i class="fas fa-plus"></i>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Situação</label>
                                    <md-select v-model="dados.situacao_id" name="pages">
                                        <md-option value="1">ATIVO</md-option>
                                        <md-option value="2">INATIVO</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-30 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Nome ou Usuário" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-30 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 10%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="NOME" style="width: 75%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="DIA PAGAMENTO" style="width: 15%">{{ item.dia_pgto }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.grupo_empresasUpdate" @click="editar(item.id)">
                                        EDITAR <md-icon class="text-warning">edit</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="dados.situacao_id == 2 && permissoes.grupo_empresasInactivate" @click="inativar(item.id, item.nome)">
                                        ATIVAR<md-icon class="text-success">thumb_up_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="dados.situacao_id == 1 && permissoes.grupo_empresasActivate" @click="inativar(item.id, item.nome)">
                                        INATIVAR<md-icon class="text-danger">thumb_down_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.grupo_empresasDelete" @click="excluir(item.id, item.nome)">
                                        EXCLUIR<md-icon class="text-danger">delete</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.grupo_empresasEliminate" @click="apagar(item.id, item.nome)">
                                        DELETAR<md-icon class="text-danger">delete_forever</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'NiveisAcessoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {
                situacao_id: 1
            },
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'grupo_empresas/',
            rotaExcluir: 'grupo_empresas/excluir/',
            rotaInactivate: 'grupo_empresas/inativar/',
            rotaActivate: 'grupo_empresas/ativar/',
            titleInactivate: 'INATIVAR?',
            columnsPDF: [20, 120, 40],
            headRowsPDF: ['ID', 'NOME', 'DIA PAGAMENTO'],
            fildsTXT: ['id', 'nome', 'dia_pgto'],
            bodyRowsPDF: ['id', 'nome', 'dia_pgto'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "NOME",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DIA PAGAMENTO",
                    field: "dia_pgto"
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: ''
            }
        };
    },

    watch: {
        'dados.situacao_id': function (value) {
            this.read()
            this.titleInactivate = value == 1 ? 'INATIVAR?' : 'ATIVAR?'
        },
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            this.buscar.situacao_id = this.dados.situacao_id
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'grupo_empresas/buscar'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'grupo_empresasUpdate',
                params: {
                    id: id
                }
            })
        },

        inativar(id, nome) {
            this.handleInactivate(id, nome)
        },

        excluir(id, nome) {
            this.handleDelete(id, nome)
        },

        apagar(id, nome) {
            this.deletar = true
            this.handleDelete(id, nome)
        }
    },

};
</script>
